import { render, staticRenderFns } from "./CheckpointsBulkArchiveDialog.vue?vue&type=template&id=f68c3470&scoped=true"
import script from "./CheckpointsBulkArchiveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointsBulkArchiveDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointsBulkArchiveDialog.vue?vue&type=style&index=0&id=f68c3470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68c3470",
  null
  
)

export default component.exports